import 'slick-carousel';

/**
 * Initialize product slider
 * @param  {String} slider - Main product slider selector
 * @param  {String} thumbs - Thumbs product slider selector
 * @return {Void}
 */

export const init = (slider = '.js-product-slider', thumbs = '.js-product-slider-thumbs') => {
	const config = {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: false,
		adaptiveHeight: true,
		asNavFor: thumbs,
	};

	const thumbsConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: false,
    arrows: false,
    infinite: false,
    asNavFor: slider,
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
					vertical: false,
					verticalSwiping: false
        },
      },
      {
        breakpoint: 570,
        settings: {
					vertical: false,
					verticalSwiping: false,
					slidesToScroll: 3,
					slidesToShow: 3
        },
      }
    ],
  };

	$(slider)
		.not('.slick-initialized')
		.slick(config);
	$(thumbs)
		.not('.slick-initialized')
		.slick(thumbsConfig);
};

init();

$(window).on('shopify:section:load', function(event) {
	init();
});
